import { defaultListFetchParams } from "misc/edmClient";
import { createContext, useEffect, useState } from "react";
import { SortPayload, useDataProvider } from "react-admin";

import {
  BackendDataContextPropsType,
  InputChoiceApiType,
  InputChoicesType,
  SettingsType,
  SettingType,
} from "./App.types";

export const InputChoicesContext = createContext<InputChoicesType>({} as InputChoicesType);
export const StartUpSettingsContext = createContext<SettingsType>({} as SettingsType);

export default function BackendDataContext(props: BackendDataContextPropsType) {
  const { children } = props;

  const dataProvider = useDataProvider();
  const payload = {
    ...defaultListFetchParams,
    pagination: { page: 1, perPage: 1000 },
    sort: { field: "id", order: "DESC" } as SortPayload,
  };

  const [inputChoices, setInputChoices] = useState<InputChoicesType>({} as InputChoicesType);
  const [startUpSettings, setStartUpSettings] = useState<SettingsType>({} as SettingsType);

  const fetchInputChoices = () =>
    dataProvider.getList<InputChoiceApiType>("input_choices", payload).then((res) => {
      const data = res.data.reduce((choices, current) => {
        choices[current.id] = current.values;
        return choices;
      }, {} as InputChoicesType);

      setInputChoices(data);
    });

  const fetchStartupSettings = () =>
    dataProvider.getList<SettingType>("startup_settings", payload).then((res) => {
      const data = res.data.reduce((settings, current) => {
        settings[current.key] = current;
        return settings;
      }, {} as SettingsType);
      setStartUpSettings(data);
    });

  useEffect(() => {
    fetchInputChoices();
    fetchStartupSettings();
  }, []);

  return (
    <StartUpSettingsContext.Provider value={startUpSettings}>
      <InputChoicesContext.Provider value={inputChoices}>{children}</InputChoicesContext.Provider>
    </StartUpSettingsContext.Provider>
  );
}
